import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  emptyInputSchema,
  markNoticeReadInputSchema,
  markAllNoticesReadOutputSchema,
  noticesForUserInputSchema,
  noticesSchema,
  notificationPreferenceSchema,
  notificationSettingsSchema,
  noticeSchema,
  setEmailDigestInputSchema,
  setNotificationChannelInputSchema,
  setNotificationEnabledInputSchema,
  setProductUpdatesInputSchema,
  setQuietHoursInputSchema,
  setSnoozeInputSchema,
  setTipsInputSchema,
  unreadNoticeCountSchema,
  unsubscribeInputSchema,
  unsubscribeOutcomeSchema,
} from "./notification.schemas.ts";

// Declared once. The process binds access and handlers; the client derives
// its hooks. `planDeliveries` and `deliverOne` are peer-only (reached only through
// `modules/worker-bridge`'s signed callback, ADR-022 points 3 and 5) and carry no tRPC
// declaration, the same way organization's `createPersonal` does.
export const notificationTrpcContract = defineTrpcContract("notification", {
  settingsForUser: query({ input: emptyInputSchema, output: notificationSettingsSchema }),
  setEnabled: mutation({ input: setNotificationEnabledInputSchema, output: notificationSettingsSchema }),
  setChannel: mutation({ input: setNotificationChannelInputSchema, output: notificationSettingsSchema }),
  noticesForUser: query({ input: noticesForUserInputSchema, output: noticesSchema }),
  unreadNoticeCount: query({ input: emptyInputSchema, output: unreadNoticeCountSchema }),
  markNoticeRead: mutation({ input: markNoticeReadInputSchema, output: noticeSchema }),
  markAllNoticesRead: mutation({ input: emptyInputSchema, output: markAllNoticesReadOutputSchema }),
  preferenceForUser: query({ input: emptyInputSchema, output: notificationPreferenceSchema }),
  setSnooze: mutation({ input: setSnoozeInputSchema, output: notificationPreferenceSchema }),
  clearSnooze: mutation({ input: emptyInputSchema, output: notificationPreferenceSchema }),
  setQuietHours: mutation({ input: setQuietHoursInputSchema, output: notificationPreferenceSchema }),
  setEmailDigest: mutation({ input: setEmailDigestInputSchema, output: notificationPreferenceSchema }),
  setProductUpdates: mutation({ input: setProductUpdatesInputSchema, output: notificationPreferenceSchema }),
  setTips: mutation({ input: setTipsInputSchema, output: notificationPreferenceSchema }),
  unsubscribeByToken: mutation({ input: unsubscribeInputSchema, output: unsubscribeOutcomeSchema }),
});
